/* @flow */
import {
  nameValidator,
  emailValidator,
  passwordValidator,
  confirmValidator,
  submitLogin,
  submitEmail,
  submitNewAccount,
  submitNewPassword,
} from './validators';

const ValidateLogin = {
  updateName: (props: Object) => (event: Object) => {
    props.updateName(event.target.value);
  },
  updateEmail: (props: Object) => (event: Object) => {
    props.updateEmail(event.target.value.toLowerCase());
  },
  updatePassword: (props: Object) => (event: Object) => {
    props.updatePassword(event.target.value);
  },
  updateConfirmation: (props: Object) => (event: Object) => {
    props.updateConfirmation(event.target.value);
  },
  validateName: (props: Object) => () => {
    const { name } = props;
    props.nameValidation(nameValidator(name));
  },
  validateEmail: (props: Object) => () => {
    const { email, informaOnly } = props;
    props.emailValidation(emailValidator(email, informaOnly));
  },
  validatePassword: (props: Object) => () => {
    props.passwordValidation(passwordValidator(props.password));
  },
  confirmPassword: (props: Object) => () => {
    const { password, confirmation } = props;
    props.confirmPassword(confirmValidator(password, confirmation));
  },
  submitLogin: (props: Object) => (event: Object) => {
    event.preventDefault();
    const { email, password, informaOnly, login } = props;
    submitLogin(email, password, informaOnly, login);
  },
  submitEmail: (props: Object) => (event: Object) => {
    event.preventDefault();
    const { email, informaOnly, askForPassword } = props;
    submitEmail(email, informaOnly, askForPassword);
  },
  submitNewAccount: (props: Object) => (event: Object) => {
    event.preventDefault();
    const {
      name,
      email,
      informaOnly,
      password,
      confirmation,
      createAccount,
      toggleError,
      updateErrorMessage,
      errorMessages,
    } = props;
    submitNewAccount(
      name,
      email,
      informaOnly,
      password,
      confirmation,
      createAccount,
      toggleError,
      updateErrorMessage,
      errorMessages
    );
  },
  submitNewPassword: (props: Object) => (event: Object) => {
    event.preventDefault();
    const {
      password,
      confirmation,
      changePassword,
      location: { query },
      toggleError,
      updateErrorMessage,
      errorMessages,
    } = props;
    const token = query && query.token;
    const email = query && query.email;
    submitNewPassword(
      password,
      confirmation,
      changePassword,
      token,
      email,
      toggleError,
      updateErrorMessage,
      errorMessages,
    );
  },
};

export default ValidateLogin;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/enhancers/ValidateLogin.js
 **/